import ReactDOM from 'react-dom';

import BaseComponent from '../BaseComponent';

export default class Portal extends BaseComponent {
  constructor(props) {
    super(props);
    this.el =
      typeof document !== 'undefined' ? document.createElement('div') : null;
  }

  componentDidMount() {
    if (typeof document !== 'undefined') {
      document.getElementsByTagName('BODY')[0].appendChild(this.el);
    }
  }

  componentWillUnmount() {
    if (typeof document !== 'undefined') {
      document.getElementsByTagName('BODY')[0].removeChild(this.el);
    }
  }

  render() {
    if (this.el) {
      return ReactDOM.createPortal(this.props.children, this.el);
    }

    return null;
  }
}
